// src/components/OfflineBanner.js
import React, { useState, useEffect } from "react";
import { useOnlineStatus, useSyncQueue } from "../hooks/useOfflineDraft";
import "./OfflineBanner.css";

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { queue, syncing } = useSyncQueue();
  const [justCameBack, setJustCameBack] = useState(false);
  const [prevOnline, setPrevOnline] = useState(true);

  useEffect(() => {
    if (!prevOnline && isOnline) {
      // Vient de revenir en ligne
      setJustCameBack(true);
      setTimeout(() => setJustCameBack(false), 4000);
    }
    setPrevOnline(isOnline);
  }, [isOnline, prevOnline]);

  // Ne rien afficher si tout va bien et pas de transition
  if (isOnline && !justCameBack && !syncing) return null;

  return (
    <div className={`offline-banner${!isOnline ? " offline" : justCameBack ? " back-online" : " syncing"}`}>
      <div className="offline-banner-inner">
        {!isOnline ? (
          <>
            <span className="offline-dot" />
            <span>🌑 Hors ligne — Tes brouillons sont sauvegardés.</span>
            {queue.length > 0 && (
              <span className="offline-queue">{queue.length} en attente de sync</span>
            )}
          </>
        ) : justCameBack ? (
          <>
            <span className="online-dot" />
            <span>✓ Connexion rétablie{queue.length > 0 ? " — synchronisation en cours..." : " — tout est à jour."}</span>
          </>
        ) : syncing ? (
          <>
            <span className="spinner" style={{width:12, height:12, borderWidth:1.5}} />
            <span>Synchronisation des brouillons...</span>
          </>
        ) : null}
      </div>
    </div>
  );
}
